import { useI18n } from "@/contexts/I18nContext";
import { Languages } from "lucide-react";

export default function LanguageSwitcher({ compact = true }) {
  const { lang, setLang } = useI18n();
  const other = lang === "ar" ? "en" : "ar";
  return (
    <button
      onClick={() => setLang(other)}
      className={`inline-flex items-center gap-1.5 font-bold rounded-lg transition ${
        compact
          ? "px-2 py-1.5 text-xs text-[var(--text-secondary)] hover:bg-[var(--surface-alt)]"
          : "px-3 py-2 text-sm bg-[var(--surface-alt)] hover:bg-[var(--border)]"
      }`}
      title={other === "en" ? "English" : "العربية"}
      data-testid="lang-switcher">
      <Languages size={compact ? 14 : 16}/>
      <span className="font-black">{other === "en" ? "EN" : "AR"}</span>
    </button>
  );
}
